import iconConfeti from "@/assets/formas/confeti.vue";

export default {
  values: {
    iconConfeti: {
      component: iconConfeti,
    },
  },
};
